module.exports = __webpack_public_path__ + "r-v3/img/img_progress2.5eabe890.svg";